import React from "react";
import "./taskfolder.css";

// Read-only full-size preview for a new-format ("TaskFolderItem") task image; no download action.
const TaskFolderImageModal = ({ image, onCloseRequest }) => {
  return (
    <div className="taskfolder-modal-container04112020">
      <div className="modalOverlay" onClick={() => onCloseRequest()}> </div>
      <div className="taskModal">
        <span className="closeButton" onClick={() => onCloseRequest()}>&nbsp;X&nbsp;</span>
        <img src={image} alt="Tehtäväkuva" />
      </div>
    </div>
  );
};

export default TaskFolderImageModal;
